// const baseUrl = process.env.REACT_APP_API_URL || "https://casenect.com:5000";
const baseUrl = "https://casenect.com:5000";

const apiRoutes = {
  baseUrl: baseUrl,
  auth: {
    login: `${baseUrl}/video/auth/login`,
    sendOtp: `${baseUrl}/video/auth/send-otp`,
    verifyOtp: `${baseUrl}/video/auth/verify-otp`,
    refreshToken: `${baseUrl}/users/refreshToken`,
  },
  cases: {
    myCases: `${baseUrl}/video/cases/myCases`,
    quickViewDetails: `${baseUrl}/video/cases/quickViewDetails`,
    caseDocuments: `${baseUrl}/video/cases/caseDocuments`,
    createCaseDoc: `${baseUrl}/video/cases/createcasedoc`,
  },
  settings: {
    generalSettings: `${baseUrl}/checklistDocuments/options`,
  },
  rooms: {
    list: `${baseUrl}/video/rooms`,
    start: `${baseUrl}/video/rooms/start`,
    complete: (roomId) => `${baseUrl}/video/rooms/${roomId}/complete`,
    waiting: (meetingCode) => `${baseUrl}/video/rooms/${meetingCode}/waiting`,
    approve: (roomCode) => `${baseUrl}/video/rooms/${roomCode}/approve`,
    reject: (roomCode) => `${baseUrl}/video/rooms/${roomCode}/reject`,
    remove: (roomCode) => `${baseUrl}/video/rooms/${roomCode}/remove`,
    joinRequest: `${baseUrl}/video/rooms/join/request`,
    adminJoin: `${baseUrl}/video/rooms/admin/join`,
    joinStatus: (meetingCode) => `${baseUrl}/video/rooms/${meetingCode}/status`,
    leave: (roomCode) => `${baseUrl}/video/rooms/${roomCode}/leave`,
  },
  token: {
    generate: `${baseUrl}/video/token/`,
  },
  recordings: {
    listByRoom: `${baseUrl}/video/recordings`,
    all: `${baseUrl}/video/recordings/all`,
    start: (sid) => `${baseUrl}/video/recordings/${sid}/start`,
    stop: (sid) => `${baseUrl}/video/recordings/${sid}/stop`,
    fromDb: (sid) => `${baseUrl}/video/recordings/${sid}/db`,
    download: (sid) => `${baseUrl}/video/recordings/${sid}/download`,
  },
  documents: {
    caseDownload: (fileName) =>
      `${baseUrl}/documents/caseDocs/${encodeURIComponent(fileName)}`,
  },
};

export default apiRoutes;
